import { Routes } from '@angular/router';

export const AuthRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./pages/landing-page/landing-page.component').then(m => m.LandingPageComponent),
    },
    {
        path: 'auth/login',
        loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
   
    },
    {
        path: 'auth/sign-up',
        loadComponent: () => import('./pages/landlord-signup/landlord-signup.component').then(m => m.LandlordSignupComponent),
   
    },
    {
        path: 'auth/nafath-login-mock',
        loadComponent: () => import('./pages/nafath-login-mock/nafath-login-mock.component').then(m => m.NafathLoginMockComponent),

    },
    // {
    //     path: 'auth/login-cred',
    //     loadComponent: () => import('./pages/login-username-password/login-username-password.component').then(m => m.LoginUsernamePasswordComponent),

    // },
    {
        path: 'auth/nafath-login',
        loadComponent: () => import('./pages/nafath-login/nafath-login.component').then(m => m.NafathLoginComponent),

    },
    {
        path: 'auth/logout',
        loadComponent: () => import('./pages/logout/logout.component').then(m => m.LogoutComponent),
    },
    {
        path: 'reset-password',
        loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    },
    {
        path: 'terms-and-conditions',
        loadComponent: () => import('../../../../../abraj-shared/src/lib/components/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent),
        data: { mode: 'page' }
    },
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: 'auth/login',
    }
]